<template>
  <div class="loan">
    <!-- Loading Spinner -->
    <div style="position: fixed; top: 50%; left: 50%; z-index: 999;">
      <atom-spinner v-if="loading" :animation-duration="speed" :size="config.size" :color="spinnersColor" />
    </div>

    <!-- Error Notification -->
    <div class="mb-3" v-if="processingError">
      <va-notification color="danger" closeable>       
        An error occurred! Please try again later.
      </va-notification>
    </div>

    <!-- Pay Slip List -->
    <div class="row" v-if="!showPdf">
      <div class="flex s12 md9">
        <va-card>
           <template #title>
    {{$t('My Pay Slips')}}
  </template>
          <va-input
            class="ma-0"
            :value="term"
            :placeholder="$t('tables.searchByName')"
            @input="search"
            removable
          >
            <va-icon name="fa fa-search" slot="prepend" />
          </va-input>
          <va-data-table :fields="fields" :data="filteredData" :per-page="10" hoverable>
            <template v-slot:month="props">
              {{ props.rowData.period }}
            </template>
            <template v-slot:gross="props">
              {{ props.rowData.grossamount | Currency }}
            </template>
            <template v-slot:deductions="props">
              {{ props.rowData.deductions }}
            </template>
            <template v-slot:netsal="props">
              {{ props.rowData.netsalary }}
            </template>
            <template v-slot:view="props">
              <va-button @click="viewPdf(props.rowData.headerno, props.rowData.period)">
                {{ $t('View') }}
              </va-button>  
            </template>
          </va-data-table>
        </va-card>
      </div>
    </div>

    <!-- PDF Viewer Section -->
    <div class="view-pdf" v-if="showPdf">
      <va-card>
       <!-- Back Button -->
       <va-button icon="fa fa-arrow-left" @click="showPdf = false">
          {{ $t('Back') }}
        </va-button>

        <!-- PDF Display -->
        <div class="row flex xs12">
          <object :data="documentPath" type="application/pdf" style="width: 100%; height: 720px;" v-if="doc">
            <p>It appears you don't have a PDF plugin for this browser. 
              <a :href="documentPath" download="document.pdf">Click here to download the file.</a>
            </p>	
          </object>
        </div>
      </va-card>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import * as spinners from 'epic-spinners';

export default {
  components: { ...spinners },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem('LoggedUser')),
      token: JSON.parse(localStorage.getItem('Token')),   
      loading: false,
      term: null,
      processingError: false,
      details: [],
      showPdf: false,
      documentPath: "",
      doc: false,
      config: { size: 80, duration: 1500 },
      spinnersColor: this.$themes.secondary,
      datepicker: { from: '', to: '' },
      showCalandar: false,
      datepickerConfig: {
        locale: { firstDayOfWeek: 1 },
        inline: false,
        position: 'below',
        altInput: true,
        minDate: new Date(new Date().setMonth(new Date().getMonth() - 6)),
        maxDate: new Date(),
      }
    };
  },
  computed: {
    fields() {
      return [
        { name: '__slot:month', title: this.$t('Month'), width: '20%' },
        { name: '__slot:gross', title: this.$t('Gross'), width: '20%' },
        { name: '__slot:deductions', title: this.$t('Deductions'), width: '20%' },
        { name: '__slot:netsal', title: this.$t('Net Salary'), width: '20%' },
        { name: '__slot:view', title: this.$t('View'), width: '15%', dataClass: 'text-center' }
      ];
    },
    filteredData() {
      if (!this.term) return this.details;
      return this.details.filter(item =>
        item.description.toLowerCase().includes(this.term.toLowerCase()) ||
        item.period.toLowerCase().includes(this.term.toLowerCase())
      );
    }
  },
  methods: {
    GetSalaryPayslips() {
      this.loading = true;
      axios.post(`${this.$apiUrl}GetSalaryPayslips`, { user: this.userData.user_id }, {
        headers: { Authorization: `${this.userData.user_id} ${this.token}` }
      })
      .then(res => {
        this.details = res.data;
        this.loading = false;
      })
      .catch(() => {
        this.processingError = true;
        this.loading = false;
      });
    },
    viewPdf(headerno) {
      this.showPdf = true;
      this.fetchPdf(headerno);
    },
    fetchPdf(headerno) {
      this.loading = true;
      let config = {
          headers: {
              Authorization: this.userData.user_id + ' ' + this.token
          }
      };

      const postData = {
          user: this.userData.user_id,
          range: `2025-01-01 to 2099-12-31`,
          code: 'MEMBPAYSLIP',
          loan: 'N/A',
          acc_code: headerno
      };
      axios.post(`${this.$apiUrl}ReadPdf`, postData, config)
      .then(res => {
        this.documentPath = `data:application/pdf;base64,${res.data.pdf}`;
        this.doc = true;
        this.loading = false;
      })
      .catch(() => {
        this.loading = false;
      });
    }
  },
  created() {
    this.GetSalaryPayslips();
  }
};
</script>
